var nBalSpn = $('back-to-top span').length;

console.log("Nbre de balise 'span' dans la balise 'back-to-top' : ", nBalSpn);

$("back-to-top").removeClass('back-to-top--active');

$("[data-icon='triangle']:eq(1)").css("margin-left", "-18px");


$("back-to-top path:eq(0)").css({
    "transform":"translateX(5px) translateY(-26px)"
  });

$("back-to-top path:eq(1)").css({
    "transform":"translateY(8px)"
});

//$("aside:eq(1)").css("display", "none");
  /*
$("back-to-top path:eq(0)").css({
    "transform":"translateX(0px) translateY(0px)"
  });

$("li span:eq(12)").css("display", "none");
*/